<template>
	<div>
		<div class="dingdan">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item :to="{ path: '/serviceHome/invitedList' }">被邀标</el-breadcrumb-item>
			  <el-breadcrumb-item>需求详情</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="fh_button" @click="fanhui" style="cursor:pointer;">
				<i class="el-icon-arrow-left"></i>
				<p>返回</p>
			</div>
		</div>
		<div class="container">
			<div class="leftsidebar">
				<div class="leftsidebarTitle">
					<h3>{{datails.name}}</h3>
					<p>发布时间：{{datails.create_time}}</p>
					<ul class="hangyeul">
						<li class="hangyeli"  v-for="(i) in datails.industries" :key="i">{{i}}</li>
					</ul>
				</div>
				<div class="leftsidebarDox">
					<div class="invitdatails">
						<h4>需求详情</h4>
						<p>{{datails.description}}</p>
					</div>
					<div class="invitimg">
						<div class="invitimg1">
							<h4>相关图片</h4>
							<div>
			<!-- 					<img v-for="(i,index) in  datails.file" :src="i" :key='index' /> -->
								<imglist :file="datails.file" type='1'></imglist>
							</div>
						</div>
						<div class="invitimg2" style="width:350px;">
							<h4>验收标准</h4>
							<div style="display:flex;">
								<div style="position:relative;margin-top:0;">
									<imglist :file="[datails.confirm_image]" v-if="datails.confirm_image"  width="72px" height="72px"></imglist>
									<img src="@/assets/kong.png" alt="" srcset=""  style="width:72px;height:72px;margin-right:10px;border-radius:6px;margin-top:0;" v-if="!datails.confirm_image"/>
									<div style="" class="dingwei">承认图</div>
								</div>
								<div style="position:relative;margin-top:0;">
									<imglist :file="[datails.produce_image]" v-if="datails.produce_image"  width="72px" height="72px"></imglist>
									<img src="@/assets/kong.png" alt="" srcset=""  style="width:72px;height:72px;margin-right:10px;border-radius:6px;margin-top:0;"  v-if="!datails.produce_image"/>
									<div style="" class="dingwei">生产图</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div class="leftsidebarDox">
					<h4>我的报价</h4>
					<div class="invitfrom">
						<ul class="invitTitle">
							<li style="width:278px;">我的信息</li>
							<li style="width:207px;">附件</li>
							<li style="width:150px;">报价金额</li>
							<li style="width:91px;">交付周期</li>
							<li style="width:128px;">报价状态</li>
						</ul>
						<ul class="invitUl" v-for="(i) in datails.quotes">
							<li class="yaobiao1" style="width:278px;">
								<div class="yaobiao1_1">
									<div style="width:100%;display: flex;align-items: center;">
										<img :src="(i.user || {}).avatar" alt="" class="yaobiaotx">
										<div class="yaobiao1_title">
											<p>{{i.user.nickname}}</p>
											<div v-if="i.is_invite==1">被邀标人</div>
										</div>
									</div>
									<div class="yaobiao1_datails"> 
										<div>
											<img src="@/assets/caller.png" alt="" srcset="" v-if="normalizeStarCount((i.user || {}).display_score)>0" />
											<span v-if="normalizeStarCount((i.user || {}).display_score)>0" style="color: #E7AA00;" >
											   {{normalizeStarCount((i.user || {}).display_score)}}
											</span>
											<span v-if="normalizeStarCount((i.user || {}).display_score)==0" style="color: #E7AA00;">暂无评分</span>
										</div>
										<span class="shu1">|</span>
										<div>
											<p>订单数量:</p>
											<span>{{i.user.total_order_num}}</span>
										</div>
										<span class="shu1">|</span>
										<div>
											<p>售后:</p>
											<span>{{i.user.aftersale_num}}</span>
										</div>
									</div>
									<div class="yaobiao1_datails"
									   style="width:100%;display:flex;overflow:hidden;overflow-x: scroll;white-space: nowrap;padding-top:10px;">
										<div v-for="(g) in i.user.userIndustries" 
										  style="margin-right:10px;padding:3px 10px;background-color:#E3F0FF;color:#4297FF;font-size:12px;border-radius:3px;">
										  {{g.name}}
										</div>
									</div>
								</div>
							</li>
							<li class="yaobiao2"  style="width:207px;">
		<!-- 						<img :src="i" alt="" srcset="" v-for="(i) in i.file" :key='i' /> -->
								<imglist :file="i.file" width="34px" height="34px"></imglist>
								<div v-if="i.file.length==0" 
								  style="width:100%;text-align: left;font-size: 14px;color: rgb(204, 204, 204);">
								    暂无报价内容
								</div>
							</li>
							<li class="yaobiao3" style="width:150px;">
								<span>￥{{i.price || 0.00}}</span>
							</li>
							<li class="yaobiao4" style="width:91px;">
								<span>{{i.period_format}}</span>
							</li>
							<li class="yaobiao5" style="width:128px;">
								<div v-if="i.is_quote==1 && i.is_select==1">已中标</div>
								<div v-else-if="i.is_quote==1 && i.is_select==0 &&  datails.status==2">未中标</div>
								<div v-else-if="i.is_quote==1">已报价</div>
								<div v-else-if="i.is_quote==0" style="background:#999;color:#fff;">未报价</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="rightsidebar">
				<div class="rightShenhe">
					<h3 class="datailsTop1_2" v-if="datails.status==1">报价中</h3>
					<h3 class="datailsTop1_2" v-if="datails.status==2 && datails.is_off==0">已结束</h3>
					<h3 class="datailsTop1_2" v-if="datails.status==2 && datails.is_off==1">平台下架</h3>
					<p v-if="datails.status==1" style="font-size: 14px;color: #FF5900;">
						 报价剩余时间:<CountDown :endTime="datails.display_end_time * 1000"></CountDown>
					</p>
					
					<p class="countdown" v-if="datails.status==2 && !datails.is_select">
						<span class="hyfooter3" v-if="datails.end_text==5">待需求方选标</span>
						<span v-else>已选其他人中标</span>
					</p>
					
					
					<!-- <p v-if="datails.status==2 && datails.is_select">
						<span style="color: #4DC800;">已中标</span>
					</p> -->
					<!-- <p v-if="datails.status==2 && !datails.is_select && datails.">
						<span>未中标</span>
					</p> -->
					
				</div>
				<div class="rightStype yaobiao1" >
					<img :src="datails.user.avatar" alt="" class="yaobiaotx">
					<div class="yaobiao1_1">
						<div class="yaobiao1_title" style="width:100%;display:inline-block;">
							<p style="width:100%;">{{datails.user.nickname}}</p>
							<div style="position: inherit;background: initial;display: flex;align-items: center;">
								<img src="@/assets/caller.png" alt="" srcset="" v-for="n in normalizeStarCount((datails.user || {}).display_score)" :key="n" />
								<span v-if="normalizeStarCount((datails.user || {}).display_score)>0" style="color: #E7AA00;">{{normalizeStarCount((datails.user || {}).display_score)}}</span>
								<span v-else style="color: #E7AA00;">暂无评分</span>
							</div>
						</div>
						<div class="yaobiao1_datails"> 
							<div>
								<p>订单数量:</p>
								<span>{{datails.user.total_order_num}}</span>
							</div>
							<span class="shu1">|</span>
							<div>
								<p>售后:</p>
								<span>{{datails.user.aftersale_num}}</span>
							</div>
						</div>
					</div>
				</div>
				<div v-if="datails.service_quote==false && datails.status==1" class="baojia">
					<div v-if="datails.invite_status==1" 
					     style="width:100%;text-align:left;font-size:14px;color:#FF5900;">
						 此需求存在被需方邀标的人进行报价
					</div>
					<div class="baojia1" >
						<el-button @click="baojia">立即报价</el-button>
					</div>
				</div>
			</div>
		</div>
		<el-dialog
		  title="报价填写"
		  :visible.sync="dialogVisible"
		  :close-on-click-modal="false"
		  width="810px">
		  <div>
			  <div class="canshu" style="text-align:left;font-size: 12px;color: rgb(255, 0, 0);margin-bottom:10px;padding-left: 120px;">
			  	 需方付款后您需要在预计周期的一半时间内上传承认图，否则会导致订单退款，生产图同理
			  </div>
			 <el-form :model="valiFormData" :rules="rules" ref="valiFormData" label-width="120px" class="demo-ruleForm">
			   <el-form-item label="报价金额" prop="price">
			     <el-input v-model="valiFormData.price" placeholder="请根据要求合理报价">
					  <template slot="append">元</template>
				 </el-input>
				<!-- invite_status -->
			   </el-form-item>
			   <el-form-item label="预计完成时间" prop="period">
			      <el-input v-model="valiFormData.period" placeholder="请根据要求合理预估时间，便于需求方评估">
					   <template slot="append">小时</template>
				  </el-input>
			   </el-form-item>
			   </el-form-item>
			   <el-form-item label="附件上传" v-if="quote_file_config==1">
			 	   <el-upload
			 	     class="upload-demo"
			 	     :action="uploadActionUrl"
			 	     :on-preview="handlePreview"
			 	     :on-remove="handleRemove"
			 	     :on-success="handleUploadSuccess"
			 	     :before-remove="beforeRemove"
			 	     :multiple='false'
			 	     :limit="4"
			 	     :on-exceed="handleExceed"
			 	     :file-list="fileList">
			 		 <div>
			 			<el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
			 			<span style="margin-left:10px;font-size: 12px;color: #FF0000;">
			 				 单个文件最大支持10M，最多不超过四个文件，仅支持png，jpg，pdf，zip文件类型
			 			</span>
			 		 </div>
			 	   </el-upload>
			   </el-form-item>
			 </el-form>
		  </div>
		  <div style="margin-top:30px;text-align: center;">
			<p style="color: #FF0000;margin-bottom:10px;font-size:12px;">提示：请如实填写报价信息，提交后不可修改</p>
			<span slot="footer" class="dialog-footer">
			  <el-button @click="dialogVisible = false">取 消</el-button>
			  <el-button type="primary" @click="submitForm('valiFormData')">确 定</el-button>
			</span>   
		  </div>
		</el-dialog>
	</div>
</template>
<script>
	import {
		DemandDetail,
		QuoteAdd,
		BaseGetConfig
	} from "@/api/api.js"
	import rightsidebarImg from '@/common/rightsidebarImg.vue';
	import CountDown from '@/common/CountDown.vue'
	import imglist from '@/common/imglist.vue';
	import config from '@/config/index'
	export default {
	  name: 'HelloWorld',
	  components:{
		rightsidebarImg,
		imglist,
		CountDown
	  },
	  data() {
	    return {
		    nametype:[
				{name:"承认图"},
				{name:"生产图"}
			],
			typeindex:0,
			datails:"" ,
			quote_file_config:"",
			
			imageUrls:[],
			fileObjects:[],
			baseURL:config.baseURL,
			dialogVisible:false,
			valiFormData: {
				price: '',
				period: '',
				file:[]
			},
			quote_file_config:"",
			rules: {
				price: [
				  { required: true, message: '报价金额不能为空', trigger: 'blur' },
				  { format: 'number', message: '报价金额只能是数字' }
				],
				period: [
				  { required: true, message: '完成周期不能为空', trigger: 'change' },
				]
			},
			fileList:[],
	    }
	  },
	  computed:{
		  d_id() {
		    return this.$route.query.d_id || ''
		  },
		  isPersonalCenterActive() {
		    const p = this.$route && this.$route.path ? this.$route.path : ''
		    return /^\/demandHome\/(demandinvoiceList|demandUserInfo|demandPromotion)(\/|$)/.test(p)
		  },
		  // 完整上传地址 = baseURL + 接口路径（若后端路径不同请改下方 '/Upload/upload'）
		  uploadActionUrl() {
		  	const base = this.baseURL || ''
		  	const path = (base.endsWith('/') ? '' : '/') + 'Upload/upload'
		  	return base + path
		  },
		  type(){
		  	return this.$route.query.type || ''
		  }
	  },
	  watch:{
		  dialogVisible:{
			  handler(newValue,oldValue){
				  if(newValue==false){
						this.valiFormData.price=""
						this.valiFormData.period=""
						this.valiFormData.file=[]
						this.fileList=[]
					  }
				  },
				 deep:true
			}
	  },
	  mounted() {
	  	this.getDemandDetail()
		this.getBaseGetConfig()
	  },
	  methods: {
		fanhui(){
		  	this.$router.go(-1)  
		},
		getDemandDetail(){
			DemandDetail(this.d_id,{}).then(res=>{
				this.datails=res.data.data
			})
		},
		getBaseGetConfig(){
			BaseGetConfig({
				key:"quote_file_config"
			}).then(res=>{
				this.quote_file_config=res.data.data.quote_file_config
			})
		},
		qiehuan(index){
			this.typeindex=index
		},
		normalizeStarCount(value) {
			const score = Number(value)
			if (!Number.isFinite(score) || score <= 0) return 0
			return Math.min(5, Math.floor(score))
		},
		
		handleExceed(files, fileList) {
		   this.$message.warning(`最多上传 4 个文件，当前已选 ${fileList.length} 个，本次选择了 ${files.length} 个，请勿超出限制`)
		},
		getUploadUrlFromResponse(response) {
		  if (!response) return ''
		  if (typeof response === 'string') return response
		  const level1 = response.data || {}
		  const level2 = level1.data || {}
		  const candidate =
			level2.url ||
			level2.file ||
			level1.url ||
			level1.file ||
			response.url ||
			response.file ||
			''
		  if (Array.isArray(candidate)) return candidate[0] || ''
		  if (typeof candidate === 'string') return candidate
		  if (Array.isArray(level1)) return level1[0] || ''
		  if (typeof level1 === 'string') return level1
		  return ''
		},
		handleUploadSuccess(response, file, fileList) {
		  this.fileList = fileList
		  const uploadedUrl = this.getUploadUrlFromResponse(response) || file.url || ''
		  if (uploadedUrl) {
			const exists = this.valiFormData.file.includes(uploadedUrl)
			if (!exists) this.valiFormData.file.push(uploadedUrl)
		  }
		},
		beforeRemove(file, fileList) {
		   this.fileList = fileList;
		   console.log(this.fileList)
		},
		handleRemove(file, fileList) {
		  this.fileList = fileList
		  const removedUrl = this.getUploadUrlFromResponse(file.response) || file.url || ''
		  if (!removedUrl) return
		  this.valiFormData.file = this.valiFormData.file.filter((url) => url !== removedUrl)
		}, 
		handlePreview(file) {
		  console.log(file)
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				this.gettijiao()
			  } else {
				return false;
			  }
			});
		},
		gettijiao(){
			this.valiFormData.file=[]
			if(this.fileList.length>0){
				this.fileList.forEach(res=>{
					this.valiFormData.file.push(res.response.data)
				})
			}
			QuoteAdd({
				...this.valiFormData,
				d_id:this.d_id,
			}).then(res=>{
				if(res.data.status==200){
					this.$message.success('提交成功！');
					this.dialogVisible=false
					this.getDemandDetail()
				}else{
					// this.$message.error(res.data.msg);
				}
			})
		},
		baojia(d_id){
			this.dialogVisible=true
		},
	  },
	}
</script>

<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.container{
		width:1200px;
		margin: 0 auto;
		display:flex;
		justify-content:space-between;
	}
	.leftsidebar{
		width:894px;
	}
	.rightsidebar{
		width:282px;
	}
	.leftsidebarTitle{
		width:100%;
		padding:20px;
		box-sizing: border-box;
		background: #FFFFFF;
		border-radius:12px;
		margin-bottom:24px;
	}
	.leftsidebarTitle p{
		font-weight: 400;
		font-size: 16px;
		color: #666666 !important;
	}
	.leftsidebarDox{
		width:100%;
		padding:20px;
		box-sizing: border-box;
		background: #FFFFFF;
		border-radius:12px;
		margin-bottom:24px;
	}
	.hangyeul{
		width:100%;
		display:flex;
		flex-wrap:wrap;
	}
	.hangyeul::-webkit-scrollbar {
		  display: none;
	}
	.hangyeli{
		font-weight: 500;
		font-size: 14px;
		color: #4297FF;
		padding:2px 5px;
		box-sizing: border-box;
		margin-right:10px;
		margin-top:8px;
		background:#E3F0FF;
		border-radius: 4px 4px 4px 4px;
	}
	.invitdatails{
		width:100%;
	}
	.invitdatails p{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin-top:12px;
	}
	.invitimg{
		width:100%;
		display:flex;
		justify-content:space-between;
		margin-top:24px;
	}
	.invitimg1 img{
		width:72px;
		height:72px;
		border-radius:6px;
		margin-right:16px;
	}
	.invitimg1 div,.invitimg2 div{
		margin-top:12px;
	}
	.invitimg2 img{
		width:72px;
		height:72px;
		border-radius:6px;
		margin-right:16px;
	}
	.invitfrom{
		width:100%;
		border:1px solid #D2D8E8;
		border-radius:12px;
		margin-top:20px;
	}
	.invitTitle{
		width:100%;
		display:flex;
		border-bottom:1px solid #D2D8E8;
	}
	.invitTitle li{
		text-align:left;
		line-height:52px;
		padding:0px 10px;
		box-sizing: border-box;
	}
	.invitUl{
		width:100%;
		display:flex;
	}
	.dingwei{
		position:absolute;
		width:72px;
		height:30px;
		display:flex;
		align-items: center;
		justify-content:center;
		color: #666;
		bottom: 0;
/* 		margin-bottom: 5px; */
		background:rgba(255,255,255,0.8);
		border-radius:6px 6px 0px 0px;
		margin-top:0 !important;
		padding-top:0 !important;
	}
	.yaobiao1{
		padding:16px 12px;
		box-sizing: border-box;
		display:flex;
	}
	.yaobiaotx{
		width:32px;
		height:32px;
		border-radius:50%;
		margin-right:12px;
	}
	.yaobiao1_title{
		width:210px;
		position: relative;
	}
	.yaobiao1_title p{
		width:140px;
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.yaobiao1_title div{
		width: 58px;
		height: 20px;
		background: rgba(255,74,78,0.15);
		border-radius: 4px ;
		text-align:center;
		line-height:20px;
		font-weight: 500;
		font-size: 12px;
		color: #FF4A4E;
		position:absolute;
		right: 0;
		top: 0;
	}
	.yaobiao1_datails{
		display:flex;
		width:210px;
		margin-top:5px;
	}
	.yaobiao1_datails img{
		width:14px;
		height:14px;
		margin-right:5px;
	}
	.yaobiao1_datails p{
		font-weight: 400;
		font-size: 12px;
		color: #666666;
	}
	.yaobiao1_datails span{
		font-weight: 400;
		font-size: 12px;
		color: #333333;
	}
	.yaobiao1_datails div{
		display:flex;
		align-items: center;
		padding: 0px 10px 0px 0px;
		box-sizing: border-box;
	}
	.shu1{
		font-size:10px;
		margin-right:10px;
	}
	.yaobiao2,.yaobiao3,.yaobiao4,.yaobiao5{
		display:flex;
		align-items: center;
		padding:16px 12px;
		box-sizing: border-box;
	}
	.yaobiao2 img{
		width:42px;
		height:42px;
		border-radius:8px;
		margin-right:5px;
	}
	.yaobiao3{
		font-weight: bold;
		font-size: 18px;
		color: #FF5900;
	}
	.yaobiao4{
		font-weight: 400;
		font-size: 16px;
		color: rgba(51,51,51,0.9);
	}
	.yaobiao5 div{
		width: 80px;
		height: 32px;
		background: #1E3A8A;
		border-radius: 8px ;
		display:flex;
		justify-content:center;
		align-items:center;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
	}
	.rightShenhe{
		width: 282px;
		height: 133px;
		background: #FFFFFF;
		border-radius: 12px ;
		display:flex;
		flex-direction: column;
		justify-content:center;
		align-items: center;
	}
	.rightShenhe h3{
		font-weight: bold;
		font-size: 24px;
		color: #E7AA00;
	}
	.rightShenhe p{
		font-weight: 500;
		font-size: 16px;
		color: #999999;
	}
	.rightStype{
		width: 282px;
		background: #FFFFFF;
		border-radius: 12px ;
		margin-top:24px;
	}
	.yaobiao1_title div{
		/* width:100%;
		display:flex;
		align-items:center; */
	}
	.yaobiao1_title div>img{
		width:14px;
		height:14px;
		margin-right:2px;
	}
	.baojia{
		width:100%;
		display:flex;
		justify-content:end;
		flex-wrap: wrap;
		margin-top:15px;
	}
	.baojia1{
		width:100%;
		margin-top:10px;
	}
	.baojia1 button{
		width:100%;
		background: #1E3A8A;
		color:#fff;
		font-size:14px;
	    border-radius: 8px;
	}
	

</style>